import * as React from 'react';
import { useState } from 'react';
import { Container, Paper, Button, Typography, Box, Collapse, Divider, TextField, InputAdornment } from '@material-ui/core';


//Redux
import { useSelector, useDispatch } from "react-redux";
import { cashRequest } from 'src/redux/actions/user.actions';


import sampleData from 'src/utils/sampleData.json';

export default function BasicCard({data, open, index, setClick, type, handleClose}) {
  const dispatch = useDispatch();
  const [values, setValues] = useState({
    amount: 0,
    name: '',
    phone: '',
    account: ''
  });
  const { user } = useSelector(state => state.auth);
  const { errors } = useSelector(state => state.ui);


  const handleChanges = prop => event => {
    setValues({...values, [prop]: event.target.value})
  }


  const handleSubmit = async (id) => {
      console.log(id)
      console.log(values)
    await dispatch(cashRequest(type, {...values, method: id}))
    .then(rs => {
      console.log(rs);
      if(rs){
      handleClose()
      }
    })
    .catch(err => {
      console.log(err);
    })
  }


  console.log(errors)


  let content = type === 'pay' &&  Object.entries(sampleData.accounts.find(a => a.id === data.id)).map(([key, value], index) => {
      let label = (data.id === 'cebuana' || data.id === 'palawan') && key === 'account' ? 'number' :  key === 'account' && data.id === 'gcash' ? 'number' : key;

      if(key !== 'id') 
      return  <TextField
      fullWidth
      variant="standard"
      label={String(label).toUpperCase()}
      margin="dense"
      value={value}
      disabled={true}
      />
})
  console.log(values)

  return (
      <Container className="center-element" >
    <Paper  elevation={3} sx={{borderRadius: '20px', height: '100%', width: '100%'}} className="m-2">
      <img src={data.logo}
      height="150px"
      width="100%"
      className="pay-logo clickable p-1"
      onClick={() => setClick(index)}
      />
    <Collapse  in={open} timeout="auto" unmountOnExit>
      <Typography variant="h4" className="text-center mt-4" >{data.label}</Typography>
      <br/>
      <Box sx={{ p: 1,  justifyContent: 'center'}} >
      <Typography variant="h6" className="text-center" >Receiver Information</Typography>
      {type === 'pay' ? content : 
        data.details.map(a => {
          return  <TextField
          key={a}
          fullWidth
          variant="standard"
          value={values[a]}
          onChange={handleChanges(a)}
          label={String(a).toUpperCase()}
          margin="dense"
          type={a === 'amount' ? 'number' : 'text'}
          error={a === 'amount' && values.amount > (user && user.current ? user.current : 0)}
          helperText={a === 'amount' && values.amount > (user && user.current ? user.current : 0) ? 'Insuffecient Fund!' : errors && errors[a]}
          InputProps={{ 
            startAdornment: a === 'phone' && (
              <InputAdornment position="start">
                +63
              </InputAdornment>
            ),
          }}
          />
        })}
        <br/>
      </Box>
      <Box className="center-element m-2">
      <Button variant="contained" onClick={() => handleSubmit(data.id)}>Submit</Button>
      </Box>

    </Collapse>
    </Paper>
  
    </Container>
  );
}
